<template>
	<nav>
		<router-view />
	</nav>
</template>

<script setup>
	import {
		useI18n
	} from 'vue-i18n';
	const {
		t
	} = useI18n();
	document.title = t('appName')
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.content {
		position: absolute;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100%;
		margin: 0 auto;
		color: #fff;
	}

	.content-title {
		font-size: 30px;
		text-align: center;
		padding-top: 5rem;
	}

	.flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	nav {
		height: 100%;
		width: 100%;
	}
</style>